export const getImportFileType = (
  selectedDataType: string,
  emissionType: string | null,
  templateType: string | null
): string => {
  if (selectedDataType === 'emissions') {
    if (emissionType === 'products') return 'emissions-product'
    if (emissionType === 'spend') return 'spend-based'
    if (emissionType === 'direct') return 'emissions-direct'
    if (emissionType === 'activity') return templateType ? `emissions-${templateType}` : 'emissions'
    return 'emissions'
  }
  return selectedDataType
}

const fileNameMap: Record<string, string> = {
  'emissions-rules': 'Activity-Based Emissions',
  'emissions-manual': 'Activity-Based Emissions',
  'emissions-direct': 'Pre-Calculated Emissions',
  'emissions-product': 'Products-Based Emissions',
  'spend-based': 'Spend-Based Emissions',
  'locations': 'Locations',
  'vehicles': 'Vehicles',
  'products': 'Products',
  'projects': 'Projects',
  'suppliers': 'Suppliers'
}

export function getTemplateFileName(fileType: string): string {
  return fileNameMap[fileType] ?? 'Template'
}

export function downloadExcel(response: any, fileName: string): void {
  const url = window.URL.createObjectURL(
    new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })
  );
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${fileName}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}


